import CoinPullReportComponent from './coin_pull_report.component';
import RouteCoinPullReportPrintModule from './print_route_coin'
import BranchCoinPullReportPrintModule from './print_branch_coin'

let CoinPullReportModule = angular.module('CoinPullReport', [
  RouteCoinPullReportPrintModule,
  BranchCoinPullReportPrintModule
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $urlRouterProvider.otherwise('/coin-pull-report');

  $stateProvider
  .state('coin-pull-report', {
    url: '/coin-pull-report',
    component: 'coinPullReport',
    data: {
      requireLogin: true,
      requireACL: 'coin_pull_report.all'
    },
    parent: 'app',
  });
})

.component('coinPullReport', CoinPullReportComponent)

.name;

export default CoinPullReportModule;


// WEBPACK FOOTER //
// ./client/app/components/coin_pull_report/index.js